import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DefaultLoader from '../../../shared/default-loader/components/default-loader';
import { getUserProfile } from '../actions/user-profile-actions';
import { getCountries } from '../../register/actions/register-actions';
import UserProfileForm from './user-profile-form';
import RenderIf from '../../../shared/render-if/components/render-if';
import PageHeader from '../../../shared/page-header/components/page-header';

import '../styles/user-profile.css';

class UserProfile extends Component {
  componentDidMount() {
    const { getUserProfile, profile, countries, getCountries } = this.props;

    if (!profile) {
      getUserProfile();
    }

    if (!countries || countries.length === 0) {
      getCountries();
    }
  }

  render() {
    const { profile, countries } = this.props;

    return (
      <div className="user-profile-container">
        <PageHeader title={'USER_PROFILE.TITLE'} />
        <RenderIf if={profile && countries && countries.length > 0}>
          <div className="row">
            <div className="col-md-12">
              <UserProfileForm />
            </div>
          </div>
        </RenderIf>
        <RenderIf if={!profile && (!countries || countries.length === 0)}>
          <DefaultLoader />
        </RenderIf>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.userProfileReducer.profile,
  countries: state.registerReducer.countries,
});

const mapDispatchToProps = dispatch => ({
  getUserProfile: () => {
    dispatch(getUserProfile());
  },
  getCountries: () => {
    dispatch(getCountries());
  },
});

UserProfile.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);



// WEBPACK FOOTER //
// ./src/app/main/user-profile/components/user-profile.js